import { ExternalLinkType, InterfaceTypes, MatricsType } from './enums';
import { ModelTypes, UserActivityTarget } from './models/APIModels';

export class Constants {
  static readonly AppName = 'ModelCentral';
  static readonly IconStyle = { color: '#51bcda' };
}

export const SEARCH_MODEL_DEFAULT_PAGINATION = {
  sortBy: '',
  descending: true,
  rowsPerPage: 20,
  page: 1,
  totalItems: 0,
  pages: 1,
  paginationId: '',
  aisearch: true,
};

export const USER_ROLE = [
  {
    id: 1,
    name: 'ReadOnly',
    label: 'Read Only',
  },
  {
    id: 2,
    name: 'Developer',
    label: 'Developer',
  },
  {
    id: 3,
    name: 'Admin',
    label: 'Admin',
  },
];

export const RECHARGE_AMOUNT = ['$1', '$5', '$10', '$50', '$500'];

export const SEO_Details = {
  title: 'ModelCentral | AI Marketplace',
  websiteUrl: 'https://ModelCentral.ai',
  description:
    'Welcome to ModelCentral! The first ever, search engine and marketplace designed exclusively for AI models, services and solutions.',
};

export const MODEL_VISIIBILITY_TYPES = [
  {
    id: 1,
    name: 'Public',
    label: 'Public',
  },
  {
    id: 2,
    name: 'Private',
    label: 'Private',
  },
  {
    id: 3,
    name: 'Under Review',
    label: 'UnderReview',
  },
];

export const MODEL_TYPES = [
  {
    id: 1,
    name: 'Indexed Model',
    label: 'IndexedModel',
  },
  {
    id: 2,
    name: 'Hosted Model',
    label: 'HostedModel',
  },
  {
    id: 3,
    name: 'Indexed Service',
    label: 'IndexedService',
  },
];
/* Categories ---

  'Generative AI',
  'Logic & Deduction',
  'Analytics',
  'Probabilistic',
  'Decision Making',
  'Regression',
  'Classification',
  'Other',

*/
export const MODEL_CATEGORIES = [
  {
    name: 'Generative AI',
    id: 'generative-ai',
  },
  {
    name: 'Logic & Deduction',
    id: 'logic-&-deduction',
  },
  {
    name: 'Analytics',
    id: 'analytics',
  },
  {
    name: 'Probabilistic',
    id: 'probabilistic',
  },
  {
    name: 'Decision Making',
    id: 'decision-making',
  },
  {
    name: 'Regression',
    id: 'regression',
  },
  {
    name: 'Classification',
    id: 'classification',
  },
  {
    name: 'Other',
    id: 'other',
  },
];

/* List of Applications

Content Creation (Images, Videos, Music, Text)
Content Editing (Images, Videos, etc.)
Data Analysis and Pattern Recognition
Decision Making
Academic Research
Business Intelligence
Architectural and Structural Planning
Search, Information Retrieval and Summarization
Strategy and Planning Tools
Customer Support
Language, Voice, Communication and Translation
Travel
Social Media
Legal and Regulatory
Machine Learning Model Training
Object Detection and Recognition
Marketing and Advertisement
Healthcare
Personalized Learning and Education
Automated Data Entry and Processing
Financial Advice and Analysis
Customized Newsletters and Email Marketing
Trading and Investment
Virtual Reality and Augmented Reality Applications
ChatBot
Other 

Convert Tags to json =>

 const newList = list.map((item) => {
      return {
          displayName: item,
        key: item.replace(/ /g, "-").toLowerCase(),
        type: "ApplicationType",
      };
});
*/
export const MODEL_TAGS = [
  {
    displayName: 'Content Creation (Images, Videos, Music, Text)',
    key: 'content-creation-(images,-videos,-music,-text)',
    type: 'ApplicationType',
  },
  {
    displayName: 'Content Editing (Images, Videos, etc.)',
    key: 'content-editing-(images,-videos,-etc.)',
    type: 'ApplicationType',
  },
  {
    displayName: 'Data Analysis and Pattern Recognition',
    key: 'data-analysis-and-pattern-recognition',
    type: 'ApplicationType',
  },
  {
    displayName: 'Decision Making',
    key: 'decision-making',
    type: 'ApplicationType',
  },
  {
    displayName: 'Academic Research',
    key: 'academic-research',
    type: 'ApplicationType',
  },
  {
    displayName: 'Business Intelligence',
    key: 'business-intelligence',
    type: 'ApplicationType',
  },
  {
    displayName: 'Architectural and Structural Planning',
    key: 'architectural-and-structural-planning',
    type: 'ApplicationType',
  },
  {
    displayName: 'Search, Information Retrieval and Summarization',
    key: 'search,-information-retrieval-and-summarization',
    type: 'ApplicationType',
  },
  {
    displayName: 'Strategy and Planning Tools',
    key: 'strategy-and-planning-tools',
    type: 'ApplicationType',
  },
  {
    displayName: 'Customer Support',
    key: 'customer-support',
    type: 'ApplicationType',
  },
  {
    displayName: 'ChatBot',
    key: 'chatbot',
    type: 'ApplicationType',
  },
  {
    displayName: 'Language, Voice, Communication and Translation',
    key: 'language,-voice,-communication-and-translation',
    type: 'ApplicationType',
  },
  {
    displayName: 'Travel',
    key: 'travel',
    type: 'ApplicationType',
  },
  {
    displayName: 'Social Media',
    key: 'social-media',
    type: 'ApplicationType',
  },
  {
    displayName: 'Legal and Regulatory',
    key: 'legal-and-regulatory',
    type: 'ApplicationType',
  },
  {
    displayName: 'Machine Learning Model Training',
    key: 'machine-learning-model-training',
    type: 'ApplicationType',
  },
  {
    displayName: 'Object Detection and Recognition',
    key: 'object-detection-and-recognition',
    type: 'ApplicationType',
  },
  {
    displayName: 'Marketing and Advertisement',
    key: 'marketing-and-advertisement',
    type: 'ApplicationType',
  },
  {
    displayName: 'Healthcare',
    key: 'healthcare',
    type: 'ApplicationType',
  },
  {
    displayName: 'Personalized Learning and Education',
    key: 'personalized-learning-and-education',
    type: 'ApplicationType',
  },
  {
    displayName: 'Automated Data Entry and Processing',
    key: 'automated-data-entry-and-processing',
    type: 'ApplicationType',
  },
  {
    displayName: 'Financial Advice and Analysis',
    key: 'financial-advice-and-analysis',
    type: 'ApplicationType',
  },
  {
    displayName: 'Customized Newsletters and Email Marketing',
    key: 'customized-newsletters-and-email-marketing',
    type: 'ApplicationType',
  },
  {
    displayName: 'Trading and Investment',
    key: 'trading-and-investment',
    type: 'ApplicationType',
  },
  {
    displayName: 'Virtual Reality and Augmented Reality Applications',
    key: 'virtual-reality-and-augmented-reality-applications',
    type: 'ApplicationType',
  },
  {
    displayName: 'Other',
    key: 'other',
    type: 'ApplicationType',
  },
];

export const MODEL_LIST = [
  {
    id: ModelTypes.HostedModel,
    name: 'UnityPredict Hosted (beta)',
    displayNameInSearch: 'UnityPredict Hosted',
    description:
      'A UnityPredict-hosed model allows ModelCentral visitors to perform inference directly on the site. UnityPredict also provides scalable API support & optional monetization options. Since users can easily experiment with your model, this option significantly increases visibility of your model and/or service.',
    linkText: 'Available by invitation only',
  },
  {
    id: ModelTypes.IndexedModel,
    name: 'AI Model',
    displayNameInSearch: 'AI Models',
    description:
      'List your open-source or proprietary AI model on ModelCentral to drive users to your site and enhance the visibility of your solution.',
    linkText: '',
  },
  {
    id: ModelTypes.IndexedService,
    name: 'AI Service',
    displayNameInSearch: 'AI Services',
    description:
      "List an existing AI SaaS solution on ModelCentral to drive traffic to your platform and boost your solution's visibility.",
    linkText: '',
  },
];

export const USER_PROFILE_ROLE = [
  {
    id: 1,
    name: 'Developer/Engineer',
    label: 'Developer/Engineer',
  },
  {
    id: 2,
    name: 'Manager/Decision Maker',
    label: 'Manager/Decision Maker',
  },
  {
    id: 3,
    name: 'Not Applicable/Personal Use',
    label: 'Not Applicable/Personal Use',
  },
  {
    id: 4,
    name: 'Other',
    label: 'Other',
  },
];

export const USER_ACTIVITY = [
  {
    id: 1,
    name: UserActivityTarget.Publisher,
    label: 'Develop, Host and/or Publish Models',
  },
  {
    id: 2,
    name: UserActivityTarget.Discover,
    label: 'Discover AI Models & Services',
  },
  {
    id: 3,
    name: UserActivityTarget.Inference,
    label: 'Use Existing Hosted/UnityPredict Models',
  },
  {
    id: 4,
    name: UserActivityTarget.ModelRequests,
    label: 'Post Model Request(s) & Connect with Experts',
  },
  {
    id: 5,
    name: UserActivityTarget.Advertise,
    label: 'Advertise and/or Monitize Existing AI Model/Solution',
  },
  {
    id: 6,
    name: UserActivityTarget.Other,
    label: 'Not Sure Yet',
  },
];

export const REFERRAL_SOURCE = [
  {
    id: 1,
    name: 'Search Engine (Google, Bing, etc.)',
    label: 'Search Engine (Google, Bing, etc.)',
  },
  {
    id: 2,
    name: 'Recommended by Friend or Colleague',
    label: 'Recommended by Friend or Colleague',
  },
  {
    id: 3,
    name: 'Social Media',
    label: 'Social Media',
  },
  {
    id: 4,
    name: 'Blog or Publication',
    label: 'Blog or Publication',
  },
  {
    id: 5,
    name: 'Other',
    label: 'Other',
  },
];

export const RECEIVE_RaM_Notifications = [
  {
    id: 1,
    name: true,
    label: 'Yes',
  },
  {
    id: 2,
    name: false,
    label: 'No',
  },
];

export const SUPPORTING_LINKS = [
  // {
  //   id: -1,
  //   name: ExternalLinkType.None,
  //   label: 'None',
  // },
  {
    id: 1,
    name: ExternalLinkType.FavIcon,
    label: 'Favicon',
  },
  {
    id: 2,
    name: ExternalLinkType.Logo,
    label: 'Logo',
  },
  {
    id: 3,
    name: ExternalLinkType.SupportingImage,
    label: 'Supporting Image',
  },
  {
    id: 4,
    name: ExternalLinkType.SupportingVideo,
    label: 'Supporting Video',
  },
  {
    id: 5,
    name: ExternalLinkType.LinkedIn,
    label: 'Linked In',
  },
  {
    id: 6,
    name: ExternalLinkType.Facebook,
    label: 'Facebook',
  },
  {
    id: 7,
    name: ExternalLinkType.Twitter,
    label: 'Twitter',
  },
  // {
  //   id: 8,
  //   name: ExternalLinkType.Other,
  //   label: 'Other',
  // },
];

export const MATRICS = [
  {
    id: 1,
    name: MatricsType.AUC,
    label: 'AUC',
  },
  {
    id: 2,
    name: MatricsType.Accuracy,
    label: 'Accuracy',
  },
  {
    id: 3,
    name: MatricsType.Recall,
    label: 'Recall',
  },
  {
    id: 4,
    name: MatricsType.Precision,
    label: 'Precision',
  },
  {
    id: 5,
    name: MatricsType.F1Score,
    label: 'F1Score',
  },
  {
    id: 6,
    name: MatricsType.R2,
    label: 'R2',
  },
  {
    id: 7,
    name: MatricsType.DunnIndex,
    label: 'DunnIndex',
  },
  {
    id: 8,
    name: MatricsType.BLEUScore,
    label: 'BLEUScore',
  },
];

export const INTERFACE_TYPES = [
  {
    id: 1,
    name: InterfaceTypes.Form,
    label: 'Form',
  },
  {
    id: 2,
    name: InterfaceTypes.Chatbot,
    label: 'Chatbot',
  },
];

export const DATA_TYPES_LIST = [
  { name: 'Boolean', id: 'Boolean', dataValue: 0 },
  { name: 'Integer', id: 'Integer', dataValue: 10 },
  { name: 'Float', id: 'Float', dataValue: 20 },
  { name: 'FloatArray', id: 'FloatArray', dataValue: 21 },
  { name: 'String', id: 'String', dataValue: 30 },
  { name: 'File', id: 'File', dataValue: 40 },
  { name: 'Dictionary', id: 'Dictionary', dataValue: 50 },
  { name: 'EmbedInputs', id: 'EmbedInputs', dataValue: 60 }
];
export const ENGINE_STATUS = {
  "Initiating": "Initiating...",
  "PreparingToUpdate" : "Engine is prepearing to update...",
  "UpdatingImage": "Updating image...",
  "InstallingPackages": "Packages are being installed...",
  "Ready": "Enging is ready to use."

}

export const Package_Definition_File_Name = 'requirements.txt';

// Pricing Page FAQ .....
export const FAQPricing = [
  {
    question: 'Why is the pricing so complicated?',
    answer: `At its core, ModelCentral is an open Marketplace. Users of ModelCentral may be looking to use AI solutions, or may be looking to build and/or sell AI solutions. The pricing structure is designed to allow this community to grow. To make things simpler, on each model page, users can see model-creator reported pricing info in addition to estimated total cost for a model (calculated using averages of previous runs).`,
  },
  {
    question: "Are there any free models?",
    answer: `Yes. There is no fee for developers and/or businesses to post and/or host models. This means that many model creators may choose to offer their solutions for free or possibly, at cost (i.e. $0 usage charge).`,
  },
];

// Pricing Plan Details .....
export const PricingPlanDetails = [
  {
    planfor: 'model-user',
    plan_name: 'Personal',
    pricing: '$0.05',
    pricingText:'/Inference',
    pricingTwo:null,
    pricingTextTwo:null,
    planOptions: [
      'Low per-inference fee ($0.05)',
      'Free to start, pay as you go',
      'Perfect for occasional use.',
      'Dashboard and analytics to track usage',
      'Find models for your needs, without a monthly fee.',
      'Experiment with models. Upgrade later.',
    ],
    cta_display: false,
  },
  {
    planfor: 'model-user',
    plan_name: 'Business',
    pricing: '$100',
    pricingText:'/month',
    pricingTwo:'$0.01',
    pricingTextTwo:'/inference',
    planOptions: [
      'Everything in the Personal plan',
      'More cost-effective for frequent users.',
      'Dedicated resources for reliable inference',
      '10 hours/month of basic support',
    ],
    cta_display: true,
  },
  {
    planfor: 'model-user',
    plan_name: 'Enterprise',
    pricing: '$500',
    pricingText:'/month',
    pricingTwo:'$0.001',
    pricingTextTwo:'/inference',
    planOptions: [
      'Everything in the Business plan',
      'Very low inference cost at scale (perfect for SaaS)',
      'Enterprise support for design & integration',
    ],
    cta_display: true,
  },
  {
    planfor: 'model-creator',
    plan_name: 'Free',
    pricing: '$0',
    pricingTwo:null,
    planOptions: [
      'Free AI model hosting',
      'List existing AI solutions for free',
      'Zero fee monitization options',
      'Dashboard and analytics to track earnings',
      'Up to 10 hours of support for hosting models',
    ],
    cta_display: true,
  },
  {
    planfor: 'model-creator',
    plan_name: 'Business',
    pricing: 'Custom Pricing',
    pricingTwo:null,
    planOptions: [
      'Everything in the free plan',
      'Business support for creating and hosting custom solutions'
    ],
    cta_display: true,
  },
];

export const EngineTypes = [
  {
    id: 1,
    name: 'MLNet',
    label: 'ML Net',
    engineTypeValue: 'MLNet',
  },
  {
    id: 2,
    name: 'ScikitLearn',
    label: 'Scikit Learn',
    engineTypeValue: 'ScikitLearn',
  },
  {
    id: 3,
    name: 'ExternalAIAPI',
    label: 'External API',
    engineTypeValue: 'ExternalAIAPI',
  },
  {
    id: 4,
    name: 'AppEngine',
    label: 'App Engine',
    engineTypeValue: 'AppEngine',
  },
];